import { DefaultMap, defined } from "@glideapps/ts-necessities";
import type { Row } from "../common/computation-model/data";
import type { RootPath } from "../common/computation-model/paths";
import { memoizeFunction } from "../common/memoize";
import type { InternalRowContext } from "../generator/components/wire";
import type { MutableTableSubscriptionSources, ValueProviderActionContext } from "./internal-types";
import type { RowSubscriptionHandler } from "./subscription";

export function makeTableSubscriptionSources(): MutableTableSubscriptionSources {
    return {
        globalKeys: new Set<string>(),
        columnsInDirectRows: new DefaultMap<string, Set<string>>(() => new Set()),
        columnsInIndirectRows: new DefaultMap<string, Set<string>>(() => new Set()),
    };
}

export const makeInternalScreenContext = memoizeFunction(
    "makeInternalScreenContext",
    (
        inputRow: Row | undefined,
        outputRow: Row | undefined,
        containingScreenRow: Row | undefined
    ): InternalRowContext => {
        return { inputRow, outputRow, containingScreenRow };
    }
);

export const emptyInternalScreenContext: InternalRowContext = makeInternalScreenContext(
    undefined,
    undefined,
    undefined
);

export function addSubscriptionHandler(
    hydrationContext: ValueProviderActionContext,
    name: string,
    handler: RowSubscriptionHandler
): RootPath {
    const path = defined(hydrationContext.namespace).addEntity(name, handler, undefined);
    hydrationContext.pathsSubscribedTo.push(path);
    return path;
}
